import { render } from "./customLoading.vue?vue&type=template&id=f52d2834&scoped=true"
import script from "./customLoading.vue?vue&type=script&lang=js"
export * from "./customLoading.vue?vue&type=script&lang=js"

import "./customLoading.vue?vue&type=style&index=0&id=f52d2834&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f52d2834"]])

export default __exports__